import { Link } from 'react-router-dom';
import { blogs, studyblogs } from '../data/blogs';

/** ---------------- CONTENT SWITCH (copy/data only) ---------------- */
const CONTENT = {
  jobsuite: {
    badge: 'OUR BLOGS',
    title: 'Find our all blogs from here',
    sub: 'Our blogs are written by deeply researched, experienced writers so you get the most practical insights.',
    dataset: blogs,
    basePath: '/jobsuite/blogs', // customize if needed
  },
  studysuite: {
    badge: 'STUDY ABROAD BLOGS',
    title: 'Study abroad insights, guides, and checklists',
    sub: 'From SOPs and scholarships to visas and timelines—learn from concise, research-backed explainers.',
    dataset: studyblogs,
    basePath: '/studysuite/blogs', // keep same path; change if you have a separate route
  },
};

/** Card */
const BlogCard = ({ post, to }) => (
  <Link
    to={to}
    className="group block bg-white rounded-2xl overflow-hidden border hover:shadow-lg transition-shadow"
  >
    <div className="aspect-[16/9] overflow-hidden">
      <img
        src={post.coverImage}
        alt={post.title}
        className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform"
      />
    </div>
    <div className="p-5">
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <span>{new Date(post.date).toLocaleDateString()}</span>
        <span>•</span>
        <span>{post.readTime} min read</span>
      </div>
      <h3 className="mt-2 text-lg font-semibold text-gray-900 line-clamp-2">{post.title}</h3>
      <p className="mt-2 text-sm text-gray-600 line-clamp-2">{post.excerpt}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {(post.tags || []).map((t) => (
          <span
            key={t}
            className="text-[11px] uppercase tracking-wide bg-gray-100 text-gray-700 px-2 py-1 rounded"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </Link>
);

/**
 * Blogs
 * @param {"jobsuite"|"studysuite"} suite - which content to show (defaults to "jobsuite")
 */
const Blogs = ({ suite = 'jobsuite' }) => {
  const S = CONTENT[suite] || CONTENT.jobsuite;
  const list = Array.isArray(S.dataset) ? S.dataset : [];

  return (
    <div className="pb-10">
      {/* Hero (full-bleed) */}
      <section className="relative overflow-hidden bg-gradient-to-b from-[#3C0F6C] to-[#6a3aa1] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16 py-12 sm:py-16">
          <p className="text-xs sm:text-sm tracking-widest opacity-80">{S.badge}</p>
          <h1 className="mt-2 text-3xl sm:text-4xl md:text-5xl font-extrabold max-w-3xl">
            {S.title}
          </h1>
          <p className="mt-4 max-w-2xl text-white/80 text-sm sm:text-base">{S.sub}</p>
        </div>
      </section>

      {/* Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16">
        <section className="mt-6 sm:mt-8 md:mt-10">
          <div className="grid gap-5 sm:gap-6 md:gap-7 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((post) => (
              <BlogCard
                key={post.slug}
                post={post}
                to={`${S.basePath}/${post.slug}`}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Blogs;
